import {
    tns
} from 'tiny-slider/src/tiny-slider';
const Barba = require('@barba/core')
var sliders = {};
export const start = async function() {
    await setTimeout(async () => {
        let containerEl = document.getElementById("carouselContainer");

        var slider = tns({
            container: '.base',
            slideBy: 'page',
            autoplay: false,
            center: false,
            swipeAngle: false,
            loop: false,
            controls: false,
            responsive: {
                360: {
                    items: 1,
                    fixedWidth: false,
                    autoWidth: true,
                    gutter: 16,
                    edgePadding: 50,
                    controls: false,
                    nav: false,
                },
                768: {
                    items: 2,
                    fixedWidth: false,
                    autoWidth: true,
                    gutter: 30,
                    controls: false,
                    nav: false,
                },
                992: {
                    items: 3,
                    fixedWidth: false,
                    autoWidth: true,
                    edgePadding: 0,
                    gutter: 48,
                    controls: false,
                    nav: false,
                }
            }
        });

        sliders = slider;
        //

        // const arrowCont = Array.from(document.getElementsByClassName('arrowContainer'))
        // arrowCont.forEach((element, i) => {
        //     element.addEventListener('mousemove', e => cursorPosition(e, element, slider, i, arrowCont.length));
        //     element.addEventListener('click', e => clickToChangePosition(e, element, slider));
        //
        // })

        updateInfos(0, containerEl)


        Array.from(containerEl.getElementsByClassName("dot")).forEach((dot, index) => {
            dot.addEventListener("click", (_e) => changeActiveIcon(index, slider, containerEl))
        })


        const rightArrow = containerEl.getElementsByClassName("right")[0]
        const leftArrow = containerEl.getElementsByClassName("left")[0]

        rightArrow.addEventListener("click", (_e) => changeActiveIcon('next', slider, containerEl))
        leftArrow.addEventListener("click", (_e) => changeActiveIcon('prev', slider, containerEl))


    }, 50)


    function changeActiveIcon(index, slider, containerEl) {
        console.log('index', index, slider.getInfo(), slider.getInfo().displayIndex)
        slider.goTo(index);
        updateInfos((slider.getInfo().displayIndex - 1), containerEl)
    }

    function updateInfos(index, containerEl) {
        const dots = Array.from(containerEl.getElementsByClassName("dot"))

        dots.forEach((dot, i) => {
            if (i == index) {
                dot.classList.add("active")
            } else {
                dot.classList.remove("active")
            }
        })
    }



    function clickToChangePosition(e, element, slider) {
        console.log('clicked', element)
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;


        if (x > (element.clientWidth / 3) * 2) {
            slider.goTo('next');
        } else {
            if (x > (element.clientWidth / 3) && x < ((element.clientWidth / 3) * 2)) {
                const hashref = element.getAttribute("hashref");
                if (hashref) {
                    // change route
                    Barba.go(hashref)
                } else {
                    if (x > (element.clientWidth / 2)) {
                        slider.goTo('next');
                    } else {
                        slider.goTo('prev');
                    }
                }
            } else {
                slider.goTo('prev');

            }


        }
    }
}




export const stop = async function() {
    var slider = sliders;
    if (slider.destroy) {
        await slider.destroy();
    }
    return true;
}
